import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  DataLayerFillEditModalContainer, type DataLayerFillEditModalProps,
} from './dataLayerFillEditModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    DataLayerFillEdit: DataLayerFillEditModalProps;
  }
}

modalRenderer.register('DataLayerFillEdit', DataLayerFillEditModalContainer);
